// Other pools tab on the Copy Pools page: pools that are not game pools (no
// `review`). Retired pools stay hidden unless Show retired pools is on
// (Odin 2026-10-31); their rows are kept.
export interface OtherPoolCategory {
  review: string | null;
  retired?: boolean;
}

export function otherPools<T extends OtherPoolCategory>(categories: T[], showRetired: boolean): T[] {
  return categories.filter((c) => !c.review && (showRetired || !c.retired));
}

export function retiredOtherPools<T extends OtherPoolCategory>(categories: T[]): T[] {
  return categories.filter((c) => !c.review && c.retired);
}
